<script>
  import {createEventDispatcher} from "svelte";
  const dispatch = createEventDispatcher();
    const elementAction = (tag) => {
      dispatch('elementAction', {tag, position, device});
  }
  export let position;
  export let device;
  let dateOptions = {year: 'numeric', month: 'long', day: 'numeric', hour: "numeric", minute: "numeric"};
  let receivedAt = new Date(position.receivedAt).toLocaleString("no-NO", dateOptions);
  position.batCritial = true;
</script>

<div class="tags">
  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Received At</span>
    <span class="tag">{receivedAt}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Speed</span>
    <span class="tag">{position.speedKmph} kmph</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Heading</span>
    <span class="tag">{position.headingDeg}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Battery</span>
    <span class="tag">{position.batV}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title" class:is-danger={position.batCritical}>Battery Critical</span>
    <span class="tag">{position.batCritical}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">In Trip</span>
    <span class="tag">{position.inTrip}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Device Eui</span>
    <span class="tag">{position.deviceEui}</span>
  </div>

  <div class="tags has-addons mb-0 mr-2">
    <span class="tag tag-title">Geofence</span>
    <span class="tag">{position.meta?.geofenceTitle || 'No match'}</span>
  </div>

</div>

<button class="button is-info is-small" on:click={() => elementAction('view-on-map')}>View on map</button>
<hr>

<style>

  .button.is-info {
    width: 120px;
  }
</style>
